import DataServiceSQL from "../DataService/DataServiceSQL";
import Utils from '../Components/Common/Utils.js';

const fill_bundle_observation_entry = (eventDate, data, id_patient) => {

  let ret = []

  data.forEach(d => {
    if (d.value !== null && d.value !== "") {
    let coding = Utils.format_fhir_response_from_datatype(d.label)
    let new_resource = {
      "resourceType" : "Observation",
      "status" : "final",
      "code" : {
        "coding" : [coding]
      },
      "subject" : id_patient,
      "component" : [{
        "code": {
          "coding": [{
            "system" : "http://loinc.org",
            "code" : coding.code,
          }],
          "text": ""
        },
        "value": {
          "valueQuantity": {
            "value": d.value,
            "system": "http://unitsofmeasure.org",
            "code": coding.code
          },
          "valueDateTime": eventDate
        }
      }]
    }
    let new_data = {request: {method: "POST", url: "Observation"}, resource: new_resource}
    ret.push(new_data)
    }
  })
  return ret
}

//Function to post data
const post_bundle_observation = async (eventDate, data, data_code, id_patient) => {
  let ret
  let sent_data = {
    "resourceType" : "Bundle",
    "type" : "transaction",
    "entry" : fill_bundle_observation_entry(eventDate, data, id_patient)
  }

  await DataServiceSQL.createObservation_fhir(sent_data)
  .then(response => {
    ret = true
  })
  .catch(e => {
    console.log("error sending data " + data_code)
    ret = false
  });
  return (ret)
}

//Function to post data
const post_observation = async (eventDate, data, data_code, id_patient) => {
  let coding = Utils.format_fhir_response_from_datatype(data_code)
  switch(data_code) {
    case "health_form":
    case "picture":
    case "kidney_device":
    case "kidney_blood":
      data = JSON.stringify(data);
      break
    case "pain":
      data = "" + data
      break
    default:
      // pass data
      break
  }


  let sent_data = {
    "resourceType" : "Observation",
    "status" : "final",
    "code" : {
      "coding" : [coding]
    },
    "subject" : id_patient,
    "component" : [{
      "code": {
        "coding": [{
          "system" : "http://loinc.org",
          "code" : coding.code,
        }],
        "text": ""
      },
      "value": {
        "valueQuantity": {
          "value": data,
          "system": "http://unitsofmeasure.org",
          "code": coding.code
        },
        "valueDateTime": eventDate
      }
  }]
  }

  let ret
  await DataServiceSQL.createObservation_fhir(sent_data)
  .then(response => {
    ret = true
  })
  .catch(e => {
    console.log("error sending data " + data_code)
    ret = false
  });
  return (ret)
}

//Const to import functions in other files
const PostFunctions = {
  post_observation,
  post_bundle_observation
};

export default PostFunctions;